import { BiddingInfo } from '@/types/BiddingInfo';
import { BidIncrement } from '@/types/BidIncrement';
import { BuyNow } from '@/types/BuyNow';
import { Catalog } from '@/types/Catalog';
import { CoverLot } from '@/types/CoverLot';
import { Item } from '@/types/item/Item';
import { Seller } from '@/types/Seller';

export type StoreFrontData = {
    bidIncrements: BidIncrement[];
    biddingInfos: BiddingInfo[];
    buyNows: BuyNow[];
    catalogs: Catalog[];
    coverLots: CoverLot[];
    items: Item[];
    sellers: Seller[];
};

export type StorefrontSlice = {
    agentName: string;
    items: number[];
    loaded: { [sellerId: number]: number };
    loading: number[];
    logoId: string;
};

/* reducer */
export const defaultStorefrontSlice: StorefrontSlice = {
    agentName: '',
    items: [],
    loaded: {},
    loading: [],
    logoId: '',
};
